import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M220-130v-650h323.84l16 80H780v360H536.16l-16-80H280v290z"></path>
  </svg>
);

export default SvgIcon;
